import * as React from 'react'

import { cn, Icons } from '@rewardops/ui'

type UserInitialPropType = {
  firstName: string
  className?: string | null
}

export const UserInitial = ({
  firstName,
  className = null,
}: UserInitialPropType) => {
  return (
    <span
      className={cn(className, 'relative flex items-center justify-center')}
    >
      <Icons.circle strokeWidth={2} />
      <span className="absolute text-xs font-extrabold" aria-hidden="true">
        {firstName[0]}
      </span>
      <span className="sr-only">{firstName}</span>
    </span>
  )
}
